import IfShield, { IF_SHIELD_NAVY, IF_SHIELD_WHITE } from './IfShield';

interface AskIfMarkProps {
  size?: number;
  showLabel?: boolean;
  className?: string;
  labelClassName?: string;
  /** onDark: white glyph (navy/gold chrome). onLight: navy glyph (pale cards). */
  tone?: 'onDark' | 'onLight';
}

/** Shield + IF mark with no square background. */
export default function AskIfMark({
  size = 20,
  showLabel = true,
  className = '',
  labelClassName = '',
  tone = 'onDark',
}: AskIfMarkProps) {
  return (
    <span className={`inline-flex items-center justify-center ${showLabel ? 'gap-1.5' : ''} ${className}`}>
      <IfShield
        color={tone === 'onLight' ? IF_SHIELD_NAVY : IF_SHIELD_WHITE}
        className="flex-shrink-0"
        style={{ width: size, height: size }}
      />
      {showLabel && <span className={labelClassName}>Ask IF</span>}
    </span>
  );
}
